// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-drawer[data-v-a4799c84]{transition:all .2s ease-in-out;background:#fff;height:100%;transition-property:width,transform,background;will-change:width,transform;z-index:2}@media(prefers-reduced-motion:reduce){.v-drawer[data-v-a4799c84]{transition:none}}.v-drawer__wrapper[data-v-a4799c84]{bottom:0;height:100%;left:0;right:0;top:0;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
